import { type ServiceContent, type HeadSpaSoin } from "../../prestations/data/types";

interface HeadSpaData {
  bannerTitle: string;
  visionSection: {
    label: string;
    title: string;
    paragraphs: string[];
  };
  quEstCeQueSection: {
    label: string;
    title: string;
    description: string;
    benefits: string[];
  };
  introSection: {
    aboveTitle: string;
    title: string;
    subtitle: string;
    content: ServiceContent[];
  };
  diagnosticSection: {
    title: string;
    content: ServiceContent[];
  };
  soins: HeadSpaSoin[];
  infosUtiles: string[];
  dureeInfo: string;
}

export const headSpaData: HeadSpaData = {
  bannerTitle: "Head Spa - L'Instant Grey",
  visionSection: {
    label: "Ma vision",
    title: "Pourquoi je fais ce que je fais ?",
    paragraphs: [
      "Pendant longtemps, j'ai cherché des espaces où je pouvais simplement être femme, sans devoir prouver, porter, cacher ou courir. Des espaces où l'on se sent entendue, accueillie, portée. Pas seulement en parole, mais aussi à travers le toucher, l'énergie, le lien.",
      "C'est dans les cercles de femmes que j'ai commencé à retrouver cette force-là. Une sororité vraie, sensible, ancrée. Des instants puissants, souvent simples, mais profondément réparateurs. Et j'ai eu envie d'emmener cette énergie dans mes soins.",
      "Le Head Spa, les soins à 4 mains, les voyages au tambour, ce ne sont pas pour moi de simples prestations. Ce sont des rituels vivants, des passerelles entre le corps et l'âme, entre soi et les autres femmes. Un prolongement naturel de cette énergie de partage, de lenteur, de retour à soi que je vis dans nos cercles.",
      "Je crois que le bien-être est sacré, qu'il mérite d'être vécu dans un cadre doux, respectueux et profondément humain. Et surtout... qu'il se partage.",
      "C'est pourquoi j'ai créé un espace où chaque soin devient une expérience, un moment pour se reconnecter à son corps, à sa vérité intérieure, et à la force du féminin collectif.",
    ],
  },
  quEstCeQueSection: {
    label: "Découverte",
    title: "Qu'est-ce que le Head Spa ?",
    description:
      "Issu du Japon, le Head Spa est un soin bien-être alliant massages crâniens, soins capillaires et relaxation profonde. Bien plus qu'un soin de beauté, c'est un véritable massage pour l'âme et l'esprit à travers la tête. Il apaise les tensions, revitalise, et offre un moment de lâcher-prise, idéal pour les personnes stressées ou en surcharge mentale. De plus en plus populaire, il séduit par ses effets durables sur le corps et l'esprit.",
    benefits: [
      "Massages crâniens et techniques d'acupression",
      "Soins capillaires et rituels énergétiques",
      "Relaxation profonde et lâcher-prise",
      "Effets durables sur le corps et l'esprit",
    ],
  },
  introSection: {
    aboveTitle: "L'Instant Grey",
    title: "Head Spa",
    subtitle:
      "Un massage pour l'âme et l'esprit à travers la tête. Il apaise les tensions, revitalise et offre un moment de lâcher-prise.",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Issu du Japon, le Head Spa est un soin bien-être alliant massages crâniens, soins capillaires et relaxation profonde. Bien plus qu'un soin de beauté, c'est un véritable massage pour l'âme et l'esprit à travers la tête. Il apaise les tensions, revitalise, et offre un moment de lâcher-prise, idéal pour les personnes stressées ou en surcharge mentale. De plus en plus populaire, il séduit par ses effets durables sur le corps et l'esprit.",
          },
        ],
      },
    ],
  },
  diagnosticSection: {
    title: "DIAGNOSTIC PERSONNALISÉ",
    content: [
      {
        type: "paragraph",
        segments: [
          {
            text: "Chaque femme, chaque chevelure, chaque cuir chevelu est unique. C'est pourquoi, avant tout soin, nous réalisons un diagnostic sur-mesure pour comprendre les besoins réels de ton cuir chevelu et de tes cheveux. Une analyss profonde sera réalisée.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "Ce bilan personnalisé nous permet d'adapter entièrement le soin à ton profil : choix des produits, des techniques, des huiles, du rythme du massage et des rituels énergétiques associés.",
          },
        ],
      },
      {
        type: "paragraph",
        segments: [
          {
            text: "Objectif : un soin qui répond exactement à ce dont tu as besoin aujourd'hui, pour un résultat visible et une sensation de bien-être durable.",
          },
        ],
      },
    ],
  },
  soins: [
    {
      name: "À la Rivière d'Eau",
      duration: "1h30 (dont 1h de soin)",
      price: "125€",
      description:
        "Imaginez-vous allongé près d'une rivière paisible… bercée par le murmure de l'eau pendant que vos tensions se dénouent. Ce soin sensoriel, profond et immersif :",
      benefits: [
        "Favorise une détente immédiate",
        "Libère le corps et l'esprit",
        "Apporte fraîcheur, apaisement et reconnexion",
      ],
    },
    {
      name: "Retour au Sens",
      duration: "1h15 (dont 45 min de soin)",
      price: "110€",
      description:
        "C'est une escale, un doux voyage au cœur de vous-même, où chaque geste, chaque parfum, chaque note Réveille en vous l'écho d'un bien-être profond. Laissez la magie de nos mains dissoudre vos tensions de la tête au cervical. Dans cette bulle de douceur, le temps s'efface ne reste que l'instant.",
      benefits: [
        "Profiter des bienfaits des huiles",
        "Laisser vos sens s'éveiller",
        "Votre esprit s'alléger",
      ],
    },
    {
      name: "Shirodhara",
      duration: "1h30 (dont 1h de soin)",
      price: "140€",
      subtitle: "Un soin rare, profond, luxueux.",
      description:
        "Inspiré des traditions indiennes, ce soin au filet d'huile chaude coulant sur le front agit sur le troisième œil. Il :",
      benefits: [
        "Apaise intensément le système nerveux",
        "Clarifie l'esprit",
        "Favorise le sommeil et la vitalité intérieure",
      ],
    },
    {
      name: "Signature Alexandra",
      duration: "1h15 (dont 45 min de soin)",
      price: "120€",
      subtitle: "Rituel au pochon chaud inspiré du Japon. Un soin profond, réconfortant, rééquilibrant.",
      description: "Les pochons aux plantes diffusent chaleur et bienfaits pour :",
      benefits: [
        "Détendre les tensions",
        "Relancer l'énergie",
        "Apaiser le système nerveux",
      ],
    },
    {
      name: "Signature Aurélie",
      duration: "1h30 (dont 45 min de soin)",
      price: "120€",
      subtitle: "Soin Terre & Mer - Un soin sensoriel, poétique et alignant.",
      description:
        "Un rituel intuitif mêlant massage cocooning, soins capillaires nourrissants et vibrations sacrées.",
      benefits: ["Nourrissant", "Enveloppant", "Ressourçant"],
    },
    {
      name: "Balinais",
      duration: "45 min (dont 30 min de soin) - 75€ / 1h (dont 45 min de soin)",
      price: "96€",
      description: "Un soin complet et personnalisé pour vous offrir détente et bien-être.",
      benefits: [
        "Massage personnalisé",
        "Soins sur mesure",
        "Séchage",
      ],
    },
    {
      name: "Rituel des 4 Mains Sacrées",
      duration: "1h30 (dont 1h de soin)",
      price: "180€",
      subtitle: "Un soin immersif et puissant.",
      description:
        "Deux praticiennes en un seul rythme travaillent en parfaite synergie pour vous détendre. Un soin exclusif à 4 mains, fluide et enveloppant, accompagné d'un voyage sonore au tambour (20 min). Idéal pour :",
      benefits: [
        "Relâcher le mental",
        "Rééquilibrer l'énergie",
        "Retrouver l'ancrage",
      ],
    },
    {
      name: 'Head Spa "Kids"',
      duration: "45 mn (dont 30 min de soin)",
      price: "60€",
      subtitle: "Un petit cocon de sérénité adapté aux enfants.",
      description:
        "Pour enfants - 12 ans (accompagnateur obligatoire) Un soin doux pour cuir chevelu sensible et cheveux en pleine croissance. Bienfaits :",
      benefits: [
        "Nettoyage délicat, hydratation, brillance",
        "Massage relaxant pour favoriser le calme et le sommeil",
      ],
    },
    {
      name: 'Bilan "Naturopathie"',
      duration: "1h30",
      price: "110€",
      description:
        "Un temps d'écoute, de compréhension et de recentrage. Un accompagnement global, bienveillant et éclairant.",
      benefits: [
        "Exploration de vos habitudes de vie",
        "Identification des déséquilibres",
        "Renforcement de l'élan de vitalité",
      ],
    },
  ],
  infosUtiles: [
    "Tout retard sera déduit du temps de prestation",
    "Merci de venir sans bijoux, sans maquillage et sans produits coiffants (laque, gel, etc.)",
    "Le séchage simple est inclus ; brushing ou coiffage sont en supplément",
  ],
  dureeInfo:
    "Chaque soin inclut environ 1h de prestation + 30 min (accueil, installation, séchage). Un moment sans précipitation, dans le respect du rythme naturel de chacun.",
};
